import React from "react";
import { Star } from "lucide-react";
import { restaurant } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import SectionBg from "./SectionBg";

export default function Hero() {
  const { t } = useLang();
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <SectionBg section="hero" lightText />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 w-full pt-28 pb-20">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-7">
            <span className="h-px w-12 bg-[#C9A24B]" />
            <span className="text-[#C9A24B] tracking-[0.35em] text-xs uppercase">{t("hero.badge")}</span>
          </div>

          <h1 className="font-display text-white text-5xl md:text-7xl leading-[1.05] mb-6">
            {t("hero.title1")}<br />
            {t("hero.title2")} <span className="italic text-[#C9A24B]">{t("hero.highlight")}</span>
          </h1>

          <p className="text-white/80 text-lg md:text-xl font-light leading-relaxed mb-9 max-w-xl">
            {t("hero.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <a href="#prenota" className="bg-[#C9A24B] hover:bg-[#d9b565] text-[#1C1815] px-8 py-4 rounded-full font-medium tracking-wide transition-all duration-300 hover:shadow-[0_12px_40px_rgba(201,162,75,0.4)] text-center">
              {t("hero.ctaBook")}
            </a>
            <a href="#menu" className="border border-white/40 hover:border-white text-white px-8 py-4 rounded-full font-medium tracking-wide transition-all duration-300 hover:bg-white/10 text-center">
              {t("hero.ctaMenu")}
            </a>
            <a href={restaurant.delivery} target="_blank" rel="noopener noreferrer"
              className="border border-white/40 hover:border-white text-white px-8 py-4 rounded-full font-medium tracking-wide transition-all duration-300 hover:bg-white/10 text-center">
              {t("hero.ctaDelivery")}
            </a>
          </div>

          <div className="flex items-center gap-5 mt-12">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((i) => (<Star key={i} size={17} className="fill-[#C9A24B] text-[#C9A24B]" />))}
            </div>
            <p className="text-white/75 text-sm">
              <span className="text-white font-semibold">{restaurant.rating}</span> · {t("hero.reviews", { n: restaurant.reviews })}
            </p>
          </div>
        </div>
      </div>

      <a href="#chisiamo" className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-white/60 text-[10px] tracking-[0.3em] uppercase">{t("hero.scroll")}</span>
        <div className="w-5 h-9 rounded-full border border-white/40 flex justify-center pt-2">
          <span className="scroll-dot w-1 h-1 rounded-full bg-[#C9A24B]" />
        </div>
      </a>
    </section>
  );
}